import course1 from "../../assets/images/course/course1.jpg";
import course2 from "../../assets/images/course/course2.jpg";
import course3 from "../../assets/images/course/course4.jpg";
import course4 from "../../assets/images/course/course5.jpg";

export const COURSE_DATA = [
  {
    id: 1,
    image: course3,
    bannerImg: "banner.png",
    name: "Civil Services",
    author: "IAS Jnani",
    authorImg: "author.png",
    lesson: "700+ Hours Coverage",
    enrolled: "Limited Seats",
    price: "₹75,000/- (Incl. GST & All Taxes)",
    regularPrice: "₹75,000/-",
    duration: "7 Months",
    type: "Offline Classroom + Personal Mentorship",
    language: "Kannada & English",
    review: "4.8",
    title:
      "IAS Jnani UPSC Foundation & Mentorship Program – March 2026 (Offline)",
  },
  {
    id: 2,
    image: course2,
    bannerImg: "banner.png",
    name: "Civil Services",
    author: "IAS Jnani",
    authorImg: "author.png",
    lesson: "700+ Hours Coverage",
    enrolled: "Open Enrollment",
    price: "₹65,000/- (Online Program)",
    regularPrice: "₹65,000/-",
    duration: "7 Months Access",
    type: "Online Recorded +  Personal Mentorship",
    language: "Kannada & English",
    review: "4.8",
    title:
      "IAS Jnani UPSC Foundation & Mentorship Program – March 2026 (Online)",
  },
  {
    id: 3,
    image: course4,
    bannerImg: "banner.png",
    name: "Civil Services",
    author: "IAS Jnani",
    authorImg: "author.png",
    lesson: "700+ Hours Coverage",
    enrolled: "Limited Seats",
    price: "₹75,000/- (Incl. GST & All Taxes)",
    regularPrice: "₹75,000/-",
    duration: "7 Months",
    type: "Offline Classroom + Personal Mentorship",
    language: "Kannada & English",
    review: "4.8",
    title:
      "IAS Jnani UPSC Foundation & Mentorship Program – October 2026 (Offline)",
  },
  {
    id: 4,
    image: course1,
    bannerImg: "banner.png",
    name: "Civil Services",
    author: "IAS Jnani",
    authorImg: "author.png",
    lesson: "700+ Hours Coverage",
    enrolled: "Open Enrollment",
    price: "₹65,000/- (Online Program)",
    regularPrice: "₹65,000/-",
    duration: "7 Months Access",
    type: "Online Recorded +  Personal Mentorship",
    language: "Kannada & English",
    review: "4.8",
    title:
      "IAS Jnani UPSC Foundation & Mentorship Program – October 2026 (Online)",
  },
];
